
import { defineComponent } from "vue";
import { ITuitionPriceListsModel } from "@/interfaces/modules";
import TuitionPriceListsService from "@/api/Collection/TuitionPriceListsService";
import AcademicYearService from "@/api/Configuration/AcademicYearService";
import type { IAcademicYearModel } from "@/interfaces/modules";
import store from "@/store";

export default defineComponent({
  name: "TuitionPriceListsContent",
  data() {
    return {
      academicYears: [] as IAcademicYearModel[],
      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: {} as ITuitionPriceListsModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      priceListTypes: [
        { value: 'MENSUALIDAD', text: 'MENSUALIDAD' },
        { value: 'OTROS', text: 'OTROS' }
      ],
      //TODO: Traer desde configuración tabla categorias de moneda
      currencyOptions: [
        { value: 'COP', text: 'COP - Peso Colombiano' },
        { value: 'USD', text: 'USD - Dólar Estadounidense' },
        { value: 'ARS', text: 'ARS - Peso Argentino' },
        { value: 'BOB', text: 'BOB - Boliviano' },
        { value: 'BRL', text: 'BRL - Real Brasileño' },
        { value: 'CLP', text: 'CLP - Peso Chileno' },
        { value: 'CRC', text: 'CRC - Colón Costarricense' },
        { value: 'CUP', text: 'CUP - Peso Cubano' },
        { value: 'DOP', text: 'DOP - Peso Dominicano' },
        { value: 'GTQ', text: 'GTQ - Quetzal Guatemalteco' },
        { value: 'HNL', text: 'HNL - Lempira Hondureño' },
        { value: 'MXN', text: 'MXN - Peso Mexicano' },
        { value: 'NIO', text: 'NIO - Córdoba Nicaragüense' },
        { value: 'PAB', text: 'PAB - Balboa Panameño' },
        { value: 'PEN', text: 'PEN - Sol Peruano' },
        { value: 'PYG', text: 'PYG - Guaraní Paraguayo' },
        { value: 'UYU', text: 'UYU - Peso Uruguayo' },
        { value: 'VES', text: 'VES - Bolívar Venezolano' }
      ],
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "AcademicYearId", label: "Año académico", sortable: true },
          { key: "Name", label: "Nombre", sortable: true },
           { key: "Type", label: "Tipo de lista de precios", sortable: true },
          { key: "Currency", label: "Moneda", sortable: true },
          { key: "EffectiveFromFormat", label: "Vigencia desde", sortable: true },
          { key: "EffectiveToFormat", label: "Vigencia hasta", sortable: true },
          { key: "Enable", label: "Activo", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as ITuitionPriceListsModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      const q = this.table.filters.search?.toLowerCase() || "";
      return q
        ? this.table.records.filter((item: ITuitionPriceListsModel) =>
          [
            item.Name,
            item.Currency,
            item.EffectiveFrom,
            item.EffectiveTo,
            item.AcademicYearId,
          ]
            .filter(Boolean)
            .some((v) => String(v).toLowerCase().includes(q))
        )
        : this.table.records;
    },
    rows(): number {
      return this.table.records?.length || 0;
    },
  },
  async mounted() {
    await this.load();
    this.academicYears = await AcademicYearService.GetAcademicYears();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await TuitionPriceListsService.GetPriceLists();
      this.table.loading = false;
    },
    async edit(data: ITuitionPriceListsModel) {
      this.form.record = await TuitionPriceListsService.GetPriceListById({ Id: data.Id } as any);

      if (this.form.record.EffectiveFrom)
        this.form.record.EffectiveFrom = this.form.record.EffectiveFrom.substring(0, 10);

      if (this.form.record.EffectiveTo)
        this.form.record.EffectiveTo = this.form.record.EffectiveTo.substring(0, 10);

      this.form.dialog = true;
    },
    openModal() {
      this.form.record = { Enable: true } as ITuitionPriceListsModel;
      this.form.dialog = true;
    },
    async handleSubmit(event: Event) {
      event.preventDefault();
      this.form.dialog = false;
      await TuitionPriceListsService.PostPriceList(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
